import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ActivatedRoute, Router, RouterStateSnapshot} from '@angular/router';
import {FormControl, FormGroup} from '@angular/forms';
import {MatChipGrid, MatChipRow} from "@angular/material/chips";
import intlTelInput from "intl-tel-input";
import {UserCardResponse} from "../../interface/userCardResponse";
import {UserCard} from "../../interface/userCard";
import {UserCardUtil} from "../../utilityClass/userCardUtil";
import {UserCardService} from "../../service/user-card.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ImageType} from "../../enums/image-type-enum";
import {UserContentComponent} from "../../user-content/user-content.component";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {UserCardContentRequest} from "../../interface/userCardContentRequest";
import {UserCardContentService} from "../../service/user-card-content.service";
import {Action} from "../../interface/action";
import {ContentResponse} from "../../interface/contentResponse";
import {ContentType} from "../../interface/contentType";
import {ContentService} from "../../service/content.service";
import {CoverImageCropperDialogComponent} from "../../cover-image-cropper-dialog/cover-image-cropper-dialog.component";
import {
  ProfileImageCropperDialogComponent
} from "../../profile-image-cropper-dialog/profile-image-cropper-dialog.component";
import {maxLengthConstant} from "../../constants/maxLength.constant";
import {Hashtag} from "../../interface/hashtag";
import {HashtagService} from "../../service/hashtag.service";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {ToggleSelectElModel} from "../../layouts/toggle-select/toggle-select-el.model";
import {ToggleElModel} from "../../layouts/toggle/toggle-el.model";
import {BehaviorSubject, interval, map, Observable, Subscription} from "rxjs";
import {DeleteProfileCardComponent} from "../delete-profile-card/delete-profile-card.component";
import {DELETE_CONTENT_TITLE, DELETE_DESCRIPTION} from "../../constants/deleteProfileCards.constant";
import {ADD_CONTENT_SUCCESS_ALERT_TEXT, USER_CARD_EDIT_BUTTON_INACTIVE_TIMEOUT} from "../../constants/global.constants";
import {EditContentDialogComponent} from "../../edit-content-dialog/edit-content-dialog.component";
import {SharedConstants} from "../../utilityClass/sharedConstants";
import {SubscriptionResponse} from "../../interface/subscriptionResponse";
import {MockupDataModel} from "../../qr-copy-message/mockup-data.model";
import {SnackBarUtil} from "../../qr-copy-message/snack-bar-util.service";
import {SubscriptionType} from "../../enums/subscription-type";
import {UserCardSubscriptionUtil} from "../../utilityClass/userCardSubscriptionUtil";
import {HASHTAGS_MAX_LENGTH} from "../../constants/validation.constants";
import {SaveChangesComponent} from "../save-changes-popup/save-changes.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-edit-profile-card',
  templateUrl: './edit-profile-card.component.html',
  styleUrls: ['./edit-profile-card.component.scss',
    '../../create-card/create-card.component.scss',
    "../../shared/scss/userCardCommon.scss",
  ],
  host: {'class': 'row'}
})
export class EditProfileCardComponent implements OnInit, OnDestroy {

  @Input() card: UserCardResponse | any;
  @Output() cardUpdated = new EventEmitter<UserCardResponse>();
  @Output() cancelClicked = new EventEmitter<boolean>();

  multiSelectLabel: string = '';
  notFoundText: 'Search' | 'No result found' | '' = 'Search';

  phone: ElementRef<HTMLInputElement> | any;
  dialogRef: MatDialogRef<UserContentComponent> | undefined;
  dialogRefDeleteContent: MatDialogRef<DeleteProfileCardComponent> | undefined;

  private cardId: string | any;
  iti: intlTelInput.Options | any;

  createCardControl: FormGroup | any;
  form: FormControl | any;

  currentProfileImage: any;
  tempProfileImageUrl: string | null = null;
  currentCoverImage: any;
  currentCompanyImage: any;
  tempCoverImageUrl: string | null = null;

  tempCoverImage: File | null = null;
  tempProfileImage: File | null = null;
  tempCompanyLogo: File | null = null;
  file: File | any
  documentFile: File | any

  contentResponse: ContentResponse | any
  updatedCardContentId: bigint | any;
  length: number | any
  characterCount: number | any;
  fieldsLengthLimit: any;
  currentQueryForSearch = '';

  userCardContents: any[] = [];
  mappedHashtagsList: any[] = [];
  matchingLineHashtags: Array<Hashtag> = [];
  userCardContentRequest: UserCardContentRequest [] = []
  userDeletedCardContentRequest: UserCardContentRequest [] = []

  pageSize: number = 10;
  scrollStep: number = 1000;
  currentPageIndexForSearch: number = 0;

  showTagError: boolean = false;
  isImageDeleted: boolean = false
  isCoverImageDeleted: boolean = false
  isCompanyImageDeleted: boolean = false
  clicked: boolean = false;
  isSingleLink: boolean = false;
  isContentViewGrid: boolean = false;
  deleteProfileImageRequested = false;
  isCurrentImageOpen = false;
  panelOpenState = true;
  showSeeMoreButton = false;
  isEditButtonInactive = false;
  currentRoute: string | null = null;
  activeSubscription!: SubscriptionResponse
  nextUrl: string | null = null;
  isRedirecting = false;
  isOpenPopup = true;

  @ViewChild('chipGrid') chipListBox: MatChipGrid | any;
  @ViewChild('chipRow') chipRow: MatChipRow | any;
  @ViewChild('inputElement') inputElement: HTMLInputElement | any;
  @ViewChild('imageInput') imageInput!: ElementRef<HTMLInputElement>;
  @ViewChild('coverImageInput') coverImageInput!: ElementRef<HTMLInputElement>;
  @ViewChild('companyLogo') companyLogo!: ElementRef<HTMLInputElement>;
  @ViewChild('ngSelectElement', {read: ElementRef}) ngSelectElement!: ElementRef;

  @ViewChildren('chipRow') chipRows: QueryList<ElementRef> | any;

  public static contentEditEmitter: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  protected readonly maxLengthConstant = maxLengthConstant;
  protected readonly ToggleElModel = ToggleElModel;
  protected readonly SharedConstants = SharedConstants;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userCardService: UserCardService,
    private userCardUtil: UserCardUtil,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private userCardContentService: UserCardContentService,
    private contentService: ContentService,
    private hashtagService: HashtagService,
    private snackBarUtil: SnackBarUtil,
    protected userCardSubscriptionUtil: UserCardSubscriptionUtil,
    private translateService: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.initializeForm();
    this.initializeCardId();
    this.fetchDefaultValues();
    this.initializePhoneInput();
    this.subscribeToCharacterCount();
    this.subscribeToContentEditEmitter();
    this.userCardContents = this.getVisibleUserCardContents();
    this.route.queryParams.subscribe(params => {
      this.currentRoute = params['currentRoute'];
      this.activeSubscription =  history.state.activeSubscription;
    })

    this.multiSelectLabel = 'user_card.max_3_allowed';
    this.translateService.onLangChange.subscribe(() => {
    });
  }

  ngOnDestroy() {
    this.userCardContentRequest = [];
  }

  returnToPreviousPage() {
    this.router.navigate([this.currentRoute]);
  }

  canDeactivate(nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.form.dirty && this.isOpenPopup) {
      if (this.isRedirecting) {
        this.isRedirecting = false;
        return true;
      }

      this.nextUrl = nextState?.url || null;
      const dialogRef = this.dialog.open(SaveChangesComponent);
      dialogRef.afterClosed().subscribe((result: boolean) => {

        if (result) {
          this.editCard()
        } else {
          this.isRedirecting = true;
          this.router.navigateByUrl(this.nextUrl || '/cards');
        }
      })
      return dialogRef.afterClosed().pipe(map(result => result == true))
    }
    return true;
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBarUtil.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data
    });
  }

  private initializeForm(): void {
    this.form = this.userCardUtil.initializeForm();
    this.createCardControl = this.form.controls;
    this.fieldsLengthLimit = this.userCardUtil.getFieldsLengthLimit();
  }

  private initializeCardId(): void {
    this.route.params.subscribe(params => {
      this.cardId = params['id'];
      if (this.cardId) {
        this.loadCardData();
        this.loadUserCardContent();
      } else {
        this.card = {};
      }
    });
  }

  private loadUserCardContent(): void {
    this.userCardContentService.getByUserCardId(this.cardId).subscribe(userCardContentResponse => {
      this.userCardContentRequest = this.mapUserCardContent(userCardContentResponse);
    });
  }

  private initializePhoneInput(): void {
    const phoneInput: HTMLInputElement | any = this.phone?.nativeElement;
    if (phoneInput) {
      this.iti = this.userCardUtil.initializeIntlTelInput(phoneInput, this.card.phoneNumber);
    }
  }

  private subscribeToCharacterCount(): void {
    this.userCardUtil.characterCount$.subscribe(count => {
      this.characterCount = count;
    });
  }

  private subscribeToContentEditEmitter(): void {
    EditProfileCardComponent.contentEditEmitter.subscribe((res: any) => {
      if (res && res.userCardContent) {
        this.afterClosedAddUserCardContent(res);
      }
    });
  }

  getNameSurnameErrorMessage() {
    return this.userCardUtil.getNameSurnameLengthErrorMessage()
  }

  getCommonFieldsErrorMessage(maxLength: number) {
    return this.userCardUtil.getCommonFieldsLengthErrorMessage(maxLength)
  }

  mapUserCardContent(userCardContentResponseList: any[]): any[] {
    return userCardContentResponseList.map(response => ({
      id: response.id,
      placeholder: response.placeholder,
      linkTitle: response.linkTitle,
      contentName: response.content.name,
      type: response.content.contentType,
      contentId: response.content.id,
      contentIcon: response.content.contentIcon,
      active: response.active,
      singleLink: response.singleLink
    }));
  }

  loadCardData(): void {
    this.userCardService.findById(this.cardId).subscribe(
      (card: UserCardResponse) => {
        this.form.patchValue({
          name: card.name,
          surname: card.surname,
          location: card.location ? card.location : '',
          company: card.company ? card.company : '',
          about: card.about ? card.about : '',
          specialization: card.specialization ? card.specialization : '',
          user: card.userId ? card.userId : '',
          hashtagList: card.tags ? card.tags : [],
          isContentViewGrid: card.contentViewGrid ? card.contentViewGrid : '',
          isSingleLink: card.singleLink,
        });
        this.card = card;
        this.isContentViewGrid = card.contentViewGrid;
        this.isSingleLink = card.singleLink;
        this.setHashtagList(card.tags);
        this.toggleEditable();
        const phoneInput: HTMLInputElement | any = this.phone?.nativeElement;
        if (phoneInput) {
          this.iti = this.userCardUtil.initializeIntlTelInput(phoneInput, this.card.countryIso);
        }
        this.currentProfileImage = card.profilePic ? this.getUserCardImage(card.id, ImageType.PROFILE_PIC) : '';
        this.currentCoverImage = card.coverImage ? this.getUserCardImage(card.id, ImageType.COVER_IMAGE) : '';
        this.currentCompanyImage = card.companyLogo ? this.getUserCardImage(card.id, ImageType.COMPANY_LOGO) : '';
      },
      () => {
        this.router.navigate(['/error-page']);
      }
    );
  }

  toggleEditable() {
    if (this.isUserCurrentSubscriptionStarter()) {
      this.form.get('name')?.disable();
      this.form.get('surname')?.disable();
    } else {
      this.form.get('name')?.enable();
      this.form.get('surname')?.enable();
    }
  }

  getUserCardImage(id: bigint, type: ImageType) {
    return this.userCardService.getCardImage(id, type);
  }

  editCard(): void {
    if (this.isEditButtonInactive) {
      return;
    }
    this.disableButtonTemporarily();
    this.form.markAllAsTouched();

    const isEditAccessible = this.form.valid && this.card && this.card.userId;
    if (!isEditAccessible) {
      return;
    }

    const updatedCard: UserCard = this.prepareEditUserCard();

    this.setUserCardIdToContentRequestIfEmpty(updatedCard.userCardContentRequest)
    this.updateFirstContentIfSingleLinkNotFound();
    this.userCardService.editCardById(this.card.id, updatedCard)
      .subscribe({
        next: (cardResponse: UserCardResponse) => {
          this.updateProfilePictures(cardResponse);
          this.isOpenPopup = false;
        },
        error: (error) => {
          if (error.status === 404) {
            this.snackBar.open('Card not found. Please check the card.', 'OK', {duration: 3000});
          }
        }
      });
  }

  setUserCardIdToContentRequestIfEmpty(userCardContentRequest: UserCardContentRequest [] = []) {
    userCardContentRequest.forEach(userCardContent => {
      if (userCardContent.userCardId === null || userCardContent.userCardId === undefined) {
        userCardContent.userCardId = this.card.id;
      }
    })
  }

  processUploadDocument(cardResponse: UserCardResponse) {
    const userCardContentWithDoc = cardResponse.userCardContent.find(userCardContent => userCardContent.content.contentType === ContentType.DOCUMENT);
    if(!userCardContentWithDoc) return;

    if (userCardContentWithDoc.placeholder.endsWith('.pdf') && this.documentFile) {
      const docData = new FormData()
      this.updatedCardContentId = userCardContentWithDoc.id;
      docData.append('documentFile', this.documentFile)
      this.uploadDocument(docData, this.updatedCardContentId)
    }
  }

  getContentIcon(image: string) {
    return this.contentService.getImage(image)
  }

  uploadDocument(formDataDoc: FormData, contentWithDocId: bigint) {
    this.userCardService.uploadDocument(formDataDoc, contentWithDocId).subscribe({
        next: () => {

        },
        error: error => {
          this.handleErrorResponse(error)
        }
      },
    );
  }

  deleteUserCardContent(userCardContent: UserCardContentRequest) {
    this.dialogRefDeleteContent = this.dialog.open(DeleteProfileCardComponent, {
      data: {
        deleteTitle: DELETE_CONTENT_TITLE,
        deleteDescription: DELETE_DESCRIPTION,
      }
    });
    this.dialogRefDeleteContent.afterClosed().subscribe((result: MatDialogRef<DeleteProfileCardComponent>) => {
      if (result) {
        const index = this.userCardContentRequest.indexOf(userCardContent);
        if (index !== -1) {
          if (!userCardContent.id) {
            this.userCardContentRequest.splice(index, 1);
          } else {
            userCardContent.action = Action.DELETED;
            this.userDeletedCardContentRequest.push(userCardContent);
            this.userCardContentRequest.splice(index, 1);
          }
        }
      }
    });
  }

  updateActiveState(userCardContent: UserCardContentRequest) {
    this.markFormAsTouchedAndDirty()
    this.userCardContentRequest.filter(item => item.active).length;
    if (userCardContent.id) {
      userCardContent.action = Action.UPDATED
    }
    userCardContent.active = !userCardContent.active
    userCardContent.singleLink = false
  }

  shouldBeDisabled(userCardContent: UserCardContentRequest): boolean {
    const subscriptionInfo = this.activeSubscription?.subscriptionInfoResponse || this.card?.subscription?.subscriptionInfoResponse;
    return this.userCardSubscriptionUtil.checkIsContentShouldBeDisabled(userCardContent, subscriptionInfo, this.userCardContentRequest);
  }

  private updateProfileImages(formData: FormData) {
    return this.userCardService.updateImage(formData, this.card.id);
  }

  openAddContentModal() {
    this.length = this.userCardContentRequest.filter(item => item.type === ContentType.DOCUMENT).length;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      userCardContentDocumentCount: this.length,
      userCardId: this.card.id
    };

    this.dialogRef = this.dialog.open(UserContentComponent, dialogConfig);
  }

  get tooltipText(): string {
    const subscriptionInfo = this.activeSubscription?.subscriptionInfoResponse
      || this.card?.subscription?.subscriptionInfoResponse;

    if (!subscriptionInfo) return '';

    // Translate the subscription title
    const title = this.translateSubscriptionTitle(subscriptionInfo.title);
    const linkCount = subscriptionInfo?.linkCount != null ?
      subscriptionInfo.linkCount.toString() :
      this.translateService.instant('subscription_plan_content.unlimited');
    const paymentMethodCount = subscriptionInfo?.paymentMethodCount;

    let paymentMethodText = '';
    if (paymentMethodCount) {
      const paymentMethodKey = paymentMethodCount === 1 ? 'payment_method' : 'payment_methods';
      paymentMethodText = `, ${paymentMethodCount} ${this.translateService.instant(`subscription_plan_content.${paymentMethodKey}`)}`;
    }

    // Use direct string interpolation instead of translation interpolation
    const format = this.translateService.instant('subscription_plan_content.subscription_info_format');
    return format
      .replace('{title}', title)
      .replace('{linkCount}', linkCount)
      .replace('{paymentMethodText}', paymentMethodText);
  }

  private translateSubscriptionTitle(title: string): string {
    // Map English titles to translation keys
    const titleMap: { [key: string]: string } = {
      'Starter': 'subscription_plans.starter',
      'Standard': 'subscription_plans.standard',
      'Premium': 'subscription_plans.premium',
      'Basic': 'subscription_plans.basic',
      'Professional': 'subscription_plans.professional',
      'Unlim': 'subscription_plans.unlim',
      'Free': 'subscription_plans.free'
    };

    const translationKey = titleMap[title];
    return translationKey ? this.translateService.instant(translationKey) : title;
  }

  getIdealDimensionsTooltip(dimensions: string): string {
    const format = this.translateService.instant('user_card.ideal_dimensions');
    return format.replace('{dimensions}', dimensions);
  }

  private afterClosedAddUserCardContent(data: { userCardContent: UserCardContentRequest, documentFile: any }) {
    const isTeamRoute = this.currentRoute === 'team';
    const subscriptionInfo = isTeamRoute ? this.activeSubscription?.subscriptionInfoResponse : this.card?.subscription?.subscriptionInfoResponse;

    this.userCardSubscriptionUtil.checkSubscriptionPermittedContentLimits(data.userCardContent, subscriptionInfo, this.userCardContentRequest)
    this.documentFile = data.documentFile
    this.userCardContentRequest.push(data.userCardContent);
    this.getContentIcon(data.userCardContent.contentIcon);

    if (this.userCardContentRequest.includes(data.userCardContent) && data.userCardContent.active) {
      this.showSnackbar(MockupDataModel.success(this.translateService.instant('alert.add_content_success')), SnackBarUtil.CLASSES.success)
    }
  }

  isUserCurrentSubscriptionStarter() {
    const subscriptionInfo = this.activeSubscription?.subscriptionInfoResponse || this.card?.subscription?.subscriptionInfoResponse;
    return subscriptionInfo?.subscriptionType === SubscriptionType.STARTER;
  }

  getVisibleUserCardContents(): UserCardContentRequest[] {
    return this.userCardContentRequest.filter(item => item.action !== Action.DELETED);
  }

  isDefaultImage(): boolean {
    return !this.tempProfileImageUrl && !this.currentProfileImage;
  }

  onImageChange(event: any, inputEl: HTMLInputElement): void {
    this.markFormAsTouchedAndDirty()
    if (event.target.files.length === 0) return;
    this.isImageDeleted = false;
    const dialogConfig = this.getDialogConfig({imageChangedEvent: event})
    const dialogRef = this.dialog.open(ProfileImageCropperDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const fileName = this.getFileName(event.target.files[0]);
        this.tempProfileImage = new File([result], fileName, {type: result.type});
        this.currentProfileImage = URL.createObjectURL(this.tempProfileImage);
      }
      inputEl.value = '';
    });
  }

  onCoverImageChange(event: any, inputEl: HTMLInputElement): void {
    this.markFormAsTouchedAndDirty()
    if (event.target.files.length === 0) return;
    this.isCoverImageDeleted = false;
    this.isCurrentImageOpen = true;
    const dialogConfig = this.getDialogConfig({imageChangedEvent: event})
    const dialogRef = this.dialog.open(CoverImageCropperDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const fileName = this.getFileName(event.target.files[0]);
        this.tempCoverImage = new File([result], fileName, {type: result.type});
        this.currentCoverImage = URL.createObjectURL(this.tempCoverImage);
      }
      inputEl.value = '';
    });
  }

  onCompanyLogoChange(event: any, inputEl: HTMLInputElement): void {
    this.markFormAsTouchedAndDirty()
    if (event.target.files.length === 0) return;
    this.isCompanyImageDeleted = false
    const dialogConfig = this.getDialogConfig({imageChangedEvent: event})
    const dialogRef = this.dialog.open(ProfileImageCropperDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const fileName = this.getFileName(event.target.files[0]);
        this.tempCompanyLogo = new File([result], fileName, {type: result.type});
        this.currentCompanyImage = URL.createObjectURL(this.tempCompanyLogo);
      }
      inputEl.value = '';
    });
  }

  getFileName(file: File): string {
    return file.name;
  }

  deleteProfileImage(): void {
    this.markFormAsTouchedAndDirty()
    this.isImageDeleted = true;
    this.deleteProfileImageRequested = true;
    this.currentProfileImage = null;
    this.tempProfileImage = null;
    this.tempProfileImageUrl = null;
  }

  deleteCoverImage(): void {
    this.markFormAsTouchedAndDirty()
    this.isCoverImageDeleted = true;
    this.isCurrentImageOpen = false;
    this.currentCoverImage = null;
    this.tempCoverImage = null;
    this.tempCoverImageUrl = null;
  }

  deleteCompanyLogo(): void {
    this.markFormAsTouchedAndDirty()
    this.isCompanyImageDeleted = true;
    this.currentCompanyImage = null;
    this.tempCompanyLogo = null;
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.userCardContentRequest, event.previousIndex, event.currentIndex);
  }

  private markFormAsTouchedAndDirty(): void {
    this.form.touched = true;
    this.form.markAsDirty();
  }

  private showSnackBar(message: string, panelClass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [panelClass]
    });
  }

  private handleErrorResponse(error: any) {
    if (error.status === 404) {
      this.showSnackBar('ContentWithDocId not found․', 'error');
    } else if (error.status === 500) {
      this.showSnackBar('Internal server error․', 'error');
    } else {
      this.showSnackBar('An unexpected error occurred․', 'error');
    }
  }

  private getDialogConfig(data: any): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.maxWidth = '700px';
    dialogConfig.width = 'auto';
    return dialogConfig;
  }

  search(term?: string) {
    this.hashtagService.getHashtags().subscribe(res => {
      this.matchingLineHashtags = res
    })
    if (term && term.trim().length > 0) {
      this.currentPageIndexForSearch = 0;
      this.currentQueryForSearch = term;
      this.showTagError = true;
      this.hashtagService.search(term, this.currentPageIndexForSearch, this.pageSize)
        .subscribe({
          next: (hashtags: Hashtag[]) => {
            this.showSeeMoreButton = hashtags.length === this.pageSize;
            this.notFoundText = 'No result found';
            this.matchingLineHashtags = hashtags;
          }
        });
    } else {
      this.notFoundText = 'Search';
      this.showSeeMoreButton = false;
    }
  }

  loadMore(): void {
    this.hashtagService.search(this.currentQueryForSearch, ++this.currentPageIndexForSearch, this.pageSize)
      .subscribe({
        next: (hashtags: Hashtag[]) => {
          this.matchingLineHashtags = this.matchingLineHashtags.concat(hashtags);
          this.showSeeMoreButton = hashtags.length === this.pageSize;
          const element = this.ngSelectElement.nativeElement.querySelector('.scroll-host');
          if (element) {
            element.scrollBy({top: this.scrollStep, behavior: 'smooth'});
          }
        }
      });
  }

  fetchDefaultValues() {
    this.hashtagService.search('', this.currentPageIndexForSearch, this.pageSize)
      .subscribe({
        next: (hashtags: Hashtag[]) => {
          if (hashtags.length === this.pageSize) {
            this.showSeeMoreButton = true;
          }
          this.notFoundText = 'No result found';
          this.matchingLineHashtags = hashtags;
        }
      });
  }

  openEditContentModal(userCardContent: UserCardContentRequest) {
    this.dialog.open(EditContentDialogComponent, {data: userCardContent}).afterClosed()
      .subscribe({
        next: (data: any) => {
          if(data.updatedContent) {
            userCardContent = data.updatedContent;
            if(!userCardContent.action) {
              userCardContent.action = Action.UPDATED;
            }
          }
          if(data.isUpdated) {
            this.documentFile = data.document
          }
        }
      });
  }

  clearMultipleSearchResult(): void {
    if (this.form.get('hashtagList').value.length === HASHTAGS_MAX_LENGTH) {
      this.notFoundText = '';
    } else {
      this.notFoundText = 'Search';
    }
    this.showTagError = true;
    if (this.form.value.hashtagList.length !== HASHTAGS_MAX_LENGTH) {
      this.fetchDefaultValues();
    } else {
      this.matchingLineHashtags = [];
    }
    this.currentQueryForSearch = '';
    this.showSeeMoreButton = false;
  }

  isSingleLinkToggleActive() {
    const accessedSingleLinkContents = this.userCardContentRequest.filter(content => content.type != ContentType.DOCUMENT);
    return accessedSingleLinkContents.length === 0 || !this.isActiveContentsPresentAndNotDocument();
  }

  isContentHighlightToggleActive() {
    return (this.isSingleLink) || this.userCardContentRequest.length === 0 || !this.isActiveContentsPresentAndNotDocument();
  }

  isControlTouchedAndInvalid(formControlName: string) {
    return this.createCardControl[formControlName].invalid
      && this.createCardControl[formControlName].touched;
  }

  isActiveContentsPresentAndNotDocument(): boolean {
    return !!this.userCardContentRequest.find(content => content.active && content.type != ContentType.DOCUMENT);
  }

  hasControlRequiredError(formControlName: string) {
    return this.createCardControl[formControlName].errors?.['required']
      || this.createCardControl[formControlName].errors?.['whitespace'];
  }

  hasControlLengthError(formControlName: string) {
    const hasLengthError = this.createCardControl[formControlName].errors?.['minlength'] || this.createCardControl[formControlName].errors?.['maxlength'];
    return hasLengthError && !this.hasControlRequiredError(formControlName);
  }

  makeContentLinkSingleByContentId(contentId: bigint, identifier: number) {
    this.resetSingleLink();
    if (identifier == null && contentId != null) {
      this.updateContentById(contentId);
    } else {
      this.updateContentByIdentifier(identifier);
    }
  }

  updateFirstContentIfSingleLinkNotFound() {
    if (!this.isSingleLink || this.userCardContentRequest.length === 0) return;

    const contents = [...this.userCardContentRequest, ...this.userDeletedCardContentRequest];
    let singleLinkFound = false;

    for (const content of contents) {
      if (content.singleLink && !singleLinkFound) {
        singleLinkFound = true;
      } else {
        content.singleLink = false;
      }
      if (content.singleLink || content.id != null) {
        content.action = content.id == null ? Action.CREATED : Action.UPDATED;
      }
    }
    if (!singleLinkFound) {
      const firstContent = this.userCardContentRequest[0];
      firstContent.singleLink = true;
      firstContent.action = firstContent.id == null ? Action.CREATED : Action.UPDATED;
    }
  }

  private resetSingleLink() {
    this.userCardContentRequest.forEach((content) => {
      if (content.singleLink) {
        content.singleLink = false;
        content.action = content.id == null ? Action.CREATED : Action.UPDATED;
      }
    })
  }

  private updateContentById(contentId: bigint) {
    const contentById = this.userCardContentRequest.find(content => content.id === contentId);
    if (contentById) {
      contentById.singleLink = true;
      contentById.action = Action.UPDATED;
    }
  }

  private updateContentByIdentifier(identifier: number) {
    const contentByIdentifier = this.userCardContentRequest.find(content => content.identifier === identifier);
    if (contentByIdentifier) {
      contentByIdentifier.singleLink = true;
      contentByIdentifier.action = contentByIdentifier.id == null ? Action.CREATED : Action.UPDATED;
    }
  }

  private mapHashtagList() {
    const hashtagList: Array<Hashtag> = <Array<Hashtag>>this.form.value.hashtagList;
    if (!hashtagList || hashtagList.length == 0) {
      return [];
    }
    let stringList: string[] = [];

    hashtagList.forEach(tag => {
      stringList.push(tag.name);
    })
    return stringList;
  }

  private setHashtagList(tags: Array<Hashtag>) {
    tags.forEach(tag => {
      this.mappedHashtagsList.push({id: tag.id, name: tag.name});
    })
    this.form.get('hashtagList').setValue(this.mappedHashtagsList);
    this.form.get('hashtagList')?.markAsUntouched();
    this.form.get('hashtagList')?.markAsPristine();

    // Subscribe to hashtagList changes to update multiSelectLabel
    const hashtagList = this.form.get('hashtagList');
    hashtagList?.valueChanges.subscribe(() => {
      this.multiSelectLabel = hashtagList.value.length == 0 ? 'user_card.max_3_allowed' : '';
    });
  }

  private prepareEditUserCard() {
    return {
      userId: this.card.userId,
      name: this.isUserCurrentSubscriptionStarter() ? this.card.name : this.form.value.name,
      surname: this.isUserCurrentSubscriptionStarter() ? this.card.surname : this.form.value.surname,
      location: this.form.value.location,
      company: this.form.value.company,
      about: this.form.value.about,
      specialization: this.form.value.specialization,
      tags: this.mapHashtagList(),
      contentViewGrid: this.isContentViewGrid,
      singleLink: this.isSingleLink,
      userCardContentRequest: this.userCardContentRequest.concat(this.userDeletedCardContentRequest)
    };
  }

  private updateProfilePictures(cardResponse: UserCardResponse) {
    const formData = new FormData();
    formData.set('profilePicture', this.tempProfileImage ? this.tempProfileImage : '');
    formData.set('isProfilePictureDeleted', String(this.isImageDeleted));

    formData.set('coverPicture', this.tempCoverImage ? this.tempCoverImage : '');
    formData.set('isCoverPictureDeleted', String(this.isCoverImageDeleted));

    formData.set('companyLogo', this.tempCompanyLogo ? this.tempCompanyLogo : '');
    formData.set('isCompanyLogoDeleted', String(this.isCompanyImageDeleted));

    this.processUploadDocument(cardResponse);

    this.updateProfileImages(formData).subscribe({
      next: () => {
        if (this.currentRoute == 'teams') {
          this.router.navigate(['/teams']).catch();
        } else {
          this.router.navigate(['/cards']).catch();
        }
      },
      error: () => {
        if (this.currentRoute == 'teams') {
          this.router.navigate(['/teams']).catch();
        } else {
          this.router.navigate(['/cards']).catch();
        }
      }
    });
  }

  private disableButtonTemporarily() {
    this.isEditButtonInactive = true;
    setTimeout(() => {
      this.isEditButtonInactive = false;
    }, USER_CARD_EDIT_BUTTON_INACTIVE_TIMEOUT);
  }

  protected readonly ContentType = ContentType;
}
